import { Util } from "../../../utils/util";

interface IValidationSubmitGuardOptions {
    container: string | HTMLElement;
    validate: () => boolean | Promise<boolean>;
    resetAnnounceCycle?: boolean;
    scrollToFirstInvalid?: boolean;
}

export class ValidationSubmitGuard {
    public static async validateAndAnnounce(options: IValidationSubmitGuardOptions): Promise<boolean> {
        const {
            container,
            validate,
            resetAnnounceCycle = true,
            scrollToFirstInvalid = true
        } = options;

        if (resetAnnounceCycle) {
            Util.resetAnnounceCycle();
        }

        Util.beginBatchAnnouncement();
        let isValid = false;
        try {
            isValid = await Promise.resolve(validate());
        } finally {
            Util.endBatchAnnouncement();
        }

        if (isValid) {
            return true;
        }

        if (scrollToFirstInvalid) {
            const containerId = typeof container === "string" ? container : container.id;
            if (containerId) {
                Util.scrollToFirstInvalidElement(containerId);
            }
        }

        Util.announceErrors(Util.collectVisibleErrors(container));
        return false;
    }
}
